<script lang="ts">
    import AutoCompletableInput from './Maps/AutoCompletableInput.svelte';

    import type { MapsAutoCompleteTypes } from '$lib/global/maps/maps.types';
    import type { Language } from '$lib/types/Language';
    import type { FormApi } from 'final-form';

    // Final Form
    export let finalFormInput;
    export let form: FormApi<any> | undefined = undefined;

    // Text
    export let name = '';
    export let placeholder = '';
    export let emoji = '';
    export let showEmoji = true;
    export let required = false;
    export let pristine = false;
    export let touched = false;
    export let active = false;

    // Validation
    export let invalid = false;
    export let errorMessage = '';

    // Styling
    export let focusColor = '';
    export let outlineColor = '';

    // Localisation
    export let language: Language = 'en';

    $: autocompleteType = (
        name === 'fullAddress' ? 'fullAddress' : 'street'
    ) as MapsAutoCompleteTypes;
</script>

<AutoCompletableInput
    type={autocompleteType}
    {placeholder}
    {emoji}
    {showEmoji}
    {invalid}
    {active}
    {pristine}
    {required}
    {focusColor}
    {outlineColor}
    {touched}
    {finalFormInput}
    {errorMessage}
    {language}
    {form}
/>
